// types
import type { HTMLProps, JSX } from "react";
import { ButtonSize } from "@/enums";
import classNames from "classnames";
import { Error } from "../error/error";

type AdditionalProps = {
  rightIcon?: JSX.Element | string;
  leftIcon?: JSX.Element | string;
  loading?: boolean;
  className?: string;
  buttonSize?: ButtonSize;
  accept?: string;
  error?: any;
};

type ButtonProps = HTMLProps<HTMLInputElement> & AdditionalProps;

const UploadButton = ({
  rightIcon,
  leftIcon,
  buttonSize = ButtonSize.MD,
  disabled,
  children,
  loading,
  className,
  onChange,
  accept = "*/*",
  error,
}: ButtonProps) => {
  const getButtonClasses = (
    disabled?: boolean,
    loading?: boolean,
    className?: string,
  ) => {
    const baseClasses =
      "flex h-[62px] items-center border px-[19px] rounded-[2.6875rem] w-full bg-[#f1f6f7] text-base font-normal text-black relative overflow-hidden";

    return classNames(
      baseClasses,
      {
        "border-transparent": !error,
        "justify-center": !rightIcon && !leftIcon,
        "border-red-500": error,
        "justify-between": rightIcon || leftIcon,
        "text-left": rightIcon,
        "bg-zinc-100 text-zinc-400 cursor-not-allowed": disabled || loading,
        "h-[3.125rem]": buttonSize === ButtonSize.SM,
        "h-[3.5rem]": buttonSize === ButtonSize.MD,
        "h-[3.875rem]": buttonSize === ButtonSize.LG,
      },
      className,
    );
  };

  const buttonClasses = getButtonClasses(disabled, loading, className);

  return (
    <div>
      <div className={buttonClasses}>
        {leftIcon && leftIcon}
        <input
          type="file"
          name="upload"
          id="upload"
          onChange={onChange}
          disabled={disabled || loading}
          className="absolute left-0 top-0 h-full w-full cursor-pointer opacity-0"
          accept={accept}
        />
        {!loading && children}
        {rightIcon && rightIcon}
      </div>
      {error && typeof error === "string" && <Error text={error} />}
    </div>
  );
};

export { UploadButton };
